import { campaignIsVisible } from './accessScope'
import type { Campaign, RegisteredAccount } from './types'

type TaskCreator = Pick<RegisteredAccount, 'profile' | 'accessScope'>

export function canCreateTaskInCampaign(account: TaskCreator, campaign: Pick<Campaign, 'clientId' | 'operation'>) {
  return campaignIsVisible(account.accessScope, campaign)
}
